import { render, staticRenderFns } from "./kpi-ficha.vue?vue&type=template&id=0cc12533&scoped=true"
import script from "./kpi-ficha.vue?vue&type=script&lang=js"
export * from "./kpi-ficha.vue?vue&type=script&lang=js"
import style0 from "./kpi-ficha.vue?vue&type=style&index=0&id=0cc12533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc12533",
  null
  
)

export default component.exports